var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20,6H17V3a1,1,0,0,0-1-1H4A1,1,0,0,0,3,3V17a1,1,0,0,0,1,1H7v3a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V7A1,1,0,0,0,20,6ZM5,16V4H15V16Zm14,4H9V18h7a1,1,0,0,0,1-1V8h2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7,
    y: 6,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7,
    y: 9,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7,
    y: 12,
    width: 6,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.24a27a7e537ff312d6c747eff1fb3e86.svg";
export { ForwardRef as ReactComponent };